{
  "more": "기타 항목"
}
